<!-- 売掛金現金回収の登録 -->
<template>
  <el-table
    :data="blendData"
    class="egl-table"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    stripe
  >
    <!-- 請求件名 -->
    <el-table-column
      prop="requestId"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.billingSubject')"
      min-width="130"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-if="!scope.row.totalRow"
          v-model="tableData[scope.$index].requestId"
          :placeholder="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.billingSubjectPlaceHolder')"
          :clearable="true"
          @change="val => changeRequestName(val, scope.$index)"
        >
          <el-option
            v-for="item in sellList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div v-else class="ta-r">{{ $locale("accountReceivable.totalAmount") }}</div>
      </template>
    </el-table-column>

    <!-- 請求明細 -->
    <el-table-column
      prop="requestDetailsId"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.billingDetail')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-model="tableData[scope.$index].requestDetailsId"
          :placeholder="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.billingDetailPlaceHolder')"
          :clearable="true"
          @change="val => changeRequestDetails(val, scope.$index)"
        >
          <el-option
            v-for="item in sellRequestDetails(scope.$index)"
            :key="item.itemId"
            :label="item.itemName"
            :value="item.itemId"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>

    <!-- 請求締日 -->
    <el-table-column
      prop="requestDeadDate"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.billingDeadline')"
      min-width="80"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.requestDeadDate | dateFormatter }}
      </template>
    </el-table-column>

    <!-- 入金予定日 -->
    <el-table-column
      prop="depositDate"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.plannedDepositDate')"
      min-width="80"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.depositDate | dateFormatter }}
      </template>
    </el-table-column>

    <!-- 売掛金残高 -->
    <el-table-column
      prop="actualAmountResidual"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.accountReceivableBalance')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.actualAmountResidual | currencyFormatter }}
      </template>
    </el-table-column>

    <!-- 現金回収金額 -->
    <el-table-column
      prop="cashRecoveryAmount"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.cashCollectionAmount')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="!scope.row.totalRow"
          :value="tableData[scope.$index].cashRecoveryAmount | currencyFormatter"
          maxlength="14"
          @input="value => inputAction(value, scope.$index)"
        ></el-input>
        <template v-else>{{ scope.row.cashRecoveryAmount | currencyFormatter(true) }}</template>
      </template>
    </el-table-column>

    <!-- 回収後売掛金残高 -->
    <el-table-column
      prop="actualAmountResidualAfter"
      :label="$locale('dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.th.accountReceivableBalanceAfterCollection')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        <template v-if="!scope.row.totalRow">{{ scope.row.actualAmountResidualAfter | currencyFormatter }}</template>
      </template>
    </el-table-column>

    <el-table-column>
      <template slot-scope="scope">
        <div class="handle ctrl" v-if="!scope.row.totalRow">
          <el-button
            v-if="tableData.length > 1 && scope.$index < tableData.length"
            class="handle-btn egl-btn-white"
            icon="el-icon-minus"
            @click="removeTableDataAction(scope.$index)"
          ></el-button>
          <el-button
            v-if="scope.$index === tableData.length - 1"
            class="handle-btn egl-btn-white"
            icon="el-icon-plus"
            @click="addTableDataAction"
          ></el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { digtalParser } from "@/utils/common";
import { accountsRecoveryBaseStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "AccountsReceivableCashCollectionRegistrationTable",
  props: {
    sellList: {
      type: Array,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    tableData: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      if (this.tableData.length === 0) {
        this.addTableDataAction();
      }

      let resultArray = tranfResData(this.tableData);

      resultArray.forEach(_item => {
        const { requestDeadDate, depositDate } = _item;

        if (!requestDeadDate) {
          _item.requestDeadDate = null;
        }

        if (!depositDate) {
          _item.depositDate = null;
        }
      });

      const _total = resultArray.map(_list => _list.cashRecoveryAmount).reduce((prev, cur) => {
        return Number(prev) + Number(cur);
      });

      const _base = accountsRecoveryBaseStruct();
      resultArray.push({
        ..._base,
        totalRow: true,
        cashRecoveryAmount: _total,
      });

      return resultArray;
    },
  },
  methods: {
    sellRequestDetails(idx) {
      if (this.sellList.length === 0) {
        return [];
      }

      const { currentSellIndex } = this.tableData[idx];
      const _target = this.sellList[currentSellIndex];
      const _resultArray = _target ? _target.records : [];
      return _resultArray;
    },
    inputAction(value, idx) {
      let _value = digtalParser(value);

      if (this.tableData[idx]) {
        this.tableData[idx].cashRecoveryAmount = _value;
        this.tableData[idx].actualAmountResidualAfter = this.tableData[idx].actualAmountResidual - Number(_value);
      }
    },
    spanMethod({ columnIndex, row }) {
      if (row.totalRow) {
        if (columnIndex === 0) {
          return [1, 4];
        } else if (columnIndex < 4) {
          return [0, 0];
        }
      }
    },
    rowClassName({ row }) {
      if (row.totalRow) {
        return "total-row";
      }
      return "";
    },
    addTableDataAction() {
      const _base = accountsRecoveryBaseStruct();
      _base.currentSellIndex = -1;
      this.tableData.push(_base);
    },
    removeTableDataAction(index) {
      this.tableData.splice(index, 1);
    },
    changeRequestName(_selectId, _idx) {
      const _tableData = tranfResData(this.tableData);

      if (_selectId) {
        const _targetIdx = this.sellList.findIndex(_list => _list.id === _selectId);

        _tableData[_idx].currentSellIndex = _targetIdx;
        _tableData[_idx].requestName = this.sellList[_targetIdx] ? this.sellList[_targetIdx].name : "";
      } else {
        const _base = accountsRecoveryBaseStruct();
        _tableData[_idx] = {
          ..._base,
          currentSellIndex: -1,
        };
      }

      this.$emit("update:tableData", _tableData);
    },
    changeRequestDetails(_selectId, _idx) {
      const _tableData = tranfResData(this.tableData);
      const { requestId, currentSellIndex } = _tableData[_idx];

      if (_selectId) {
        const _currentSell = this.sellList[currentSellIndex];
        const { records } = _currentSell;
        const _targetObj = records.find(_rec => _rec.itemId === _selectId);
        const {
          actualAmountResidual,
          depositDate,
          requestDeadDate,
          itemName,
        } = _targetObj;

        _tableData[_idx] = {
          ..._tableData[_idx],
          actualAmountResidualAfter: 0,
          actualAmountResidual,
          cashRecoveryAmount: actualAmountResidual,
          depositDate,
          requestDeadDate,
          requestDetails: itemName,
        };
      } else {
        const _base = accountsRecoveryBaseStruct();

        _tableData[_idx] = {
          ..._base,
          requestId,
          currentSellIndex,
        };
      }

      this.$emit("update:tableData", _tableData);
    },
  },
};
</script>
